<template>
  <div>
    <div class="home-category" v-if="categoryList.length">
      <article>
        <a
          class="category-item"
          v-for="(item, index) in categoryList"
          :href="item.link"
          @click="toCategoryItem(item, index)"
          :key="item.link"
        >
          <img :src="item.img" v-if="item.img" />
          <span>{{ item.title }}</span>
        </a>
        <a class="category-item" @click="toCategorylist">
          <img :src="categoryAllImg" v-if="categoryAllImg" />
          <span>全部</span>
        </a>
      </article>
    </div>
  </div>
</template>
<script>
import categoryAllImg from '@/assets/images/category_all@3x.png'
import { isNullOrEmpty } from '../../utils'
import util from '@/plugins/utils'
export default {
  props: ['categoryData', 'citycode'],
  data() {
    return {
      categoryAllImg
    }
  },
  computed: {
    categoryList() {
      const categoryData = this.categoryData.map(item => {
        if (item.link && item.link.indexOf('life.cekid.com/y/home') > -1) {
          try {
            const linkArry = item.link.split('?')
            let origin = '',
              search = ''
            if (linkArry.length > 0) {
              origin = linkArry[0]
              search = linkArry.length > 1 ? linkArry[1] : ''
            }
            search = `?${search}`
            let parsed = this.$$queryString.parse(search)
            parsed = { ...parsed, citycode: this.citycode }
            item.link = `${origin}?${this.$$queryString.stringify(parsed)}`
          } catch (e) {}
        } else {
          item.link = util.transformVh5UrlSwt(item.link)
        }
        return item
      })
      return (categoryData || [])
        .filter(x => !isNullOrEmpty(x.link))
        .slice(0, 7)
    }
  },
  methods: {
    toCategoryItem(item, index) {
      try {
        const uid = this.$$cookie('uid') || ''
        const id = 200011 + index
        this.trackClick(
          id,
          {
            surl: item.link || '',
            infotitle: item.title || '',
            citycode: this.citycode,
            fuid: uid
          },
          `surl: ${item.link}, infotitle: ${item.title}, citycode: ${this.citycode}, fuid: ${uid}`,
          121011908
        )
      } catch (e) {
        console.log(e)
      }
    },
    toCategorylist() {
      try {
        const uid = this.$$cookie('uid') || ''
        this.trackClick(
          200018,
          {
            surl: 'https://life.cekid.com/v/categorylist',
            infotitle: '全部品类',
            citycode: this.citycode,
            fuid: uid
          },
          `surl: https://life.cekid.com/v/categorylist, infotitle: 全部品类, citycode: ${this.citycode}, fuid: ${uid}`,
          121011908
        )
      } catch (e) {
      } finally {
        const query = this.$route.query
        this.$router.push({ name: 'categorylist', query })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/mixin';
.home-category {
  position: relative;

  article {
    background-color: #fff;

    width: 100%;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: rem(36px);
      background-color: #fff;
      z-index: 6;
      top: rem(-36px);
      border-top-right-radius: rem(30px);
      border-top-left-radius: rem(30px);
    }
  }
  .category-item {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding-top: rem(4px);
    padding-bottom: rem(30px);
    width: 25%;
    img {
      width: rem(90px);
      height: rem(90px);
    }
    span {
      font-size: rem(24px);
      color: #121212;
      display: inline-block;
      max-width: rem(140px);
      text-align: center;
      margin: 0 auto;
      margin-top: rem(12px);
      line-height: rem(30px);
      @include ellicpsis;
    }
  }
}
</style>
